let obj = {};
obj.guarantPre = [
    {
        key: '1',
        value: "1个月",
    },
    {
        key: '2',
        value: "2个月",
    },
    {
        key: '3',
        value: "3个月"
    },
    {
        key: '4',
        value: "4个月",
    },
    {
        key: '5',
        value: "5个月",
    },
    {
        key: '6',
        value: "6个月"
    },
    {
        key: '7',
        value: "7个月"
    },
    {
        key: '8',
        value: "8个月"
    },
    {
        key: '9',
        value: "9个月"
    },
    {
        key: '10',
        value: "10个月"
    },
    {
        key: '12',
        value: "12个月"
    }
]
obj.companyIdTypeOptions = [
    {
        value: "03",
        name: "统一社会信用代码"
    },
]
obj.companyIdTypeOptionsOther = [
    {
        value: "01",
        name: "组织机构代码证",
    },
    {
        value: "04",
        name: "工商营业执照"
    },
    {
        value: "99",
        name: "其他",
    },
]
obj.companyPropertyList = [
    {
        value: "01",
        text: "国家机关",
    },
    {
        value: "02",
        text: "国有事业单位",
    },
    {
        value: "03",
        text: "国有企业",
    },
    // {
    //     value: "04",
    //     text: "私营",
    // },
    // {
    //     value: "05",
    //     text: "个体工商",
    // },
    {
        value: "06",
        text: "上市公司",
    },
    {
        value: "99",
        text: "其它",
    },
]
obj.cunxuTimeList = [
    {
        value: "2",
        text: "3年以下",
    },
    {
        value: "3",
        text: "3年及以上",
    },
]
obj.KZSCOptions = [
    {
        value: -1,
        name: "不附加",
    },
    {
        value: 0,
        name: "附加",
    },
]
obj.YWZYJTOptions = [
    {
        value: 100,
        name: "100/天",
    }
]
obj.YWZBOptions = [
    {
        value: 2000,
        name: "2000/周",
    }, {
        value: 3000,
        name: "3000/周",
    }
]
obj.occupationOptionsLevel = [
    {
        value: '1',
        name: "1类",
    }, {
        value: '2',
        name: "2类",
    }, {
        value: '3',
        name: "3类",
    }, {
        value: '4',
        name: "4类",
    }, {
        value: '5',
        name: "5类",
    }, {
        value: '6',
        name: "6类",
    }
]
obj.IdTypeOptions = [
    {
        value: '1',
        name: '居民身份证'
    },
    {
        value: '10',
        name: '外国护照'
    },
    {
        value: '26',
        name: '港澳台居民居住证'
    },
    {
      value:'99',
      name:'其它'
    },
]
obj.sexOptions = [
    {
        value: 'M',
        name: '男'
    },
    {
        value: 'F',
        name: '女'
    },
]
obj.countData = {
    YWSGSC: 1000000, //意外身故及伤残保障
    YWYYBT: 200000, //意外医药补贴
    YWMRJT: 100, //意外每日住院津贴
    FJSG: 2000000, // 飞机身故
    HCSG: 1000000, // 火车身故
    CS: 800000,//猝死
    BF: 550, // 保费 550/年
}
obj.plansValues = [
    {
        name: '计划一',
        value: 'ZYBDTTYWXA',
        optionSelect: {
            YWSGSC: 100000, //意外身故及伤残保障
            YWYYBT: 10000, //意外医药补贴
            YWMRJT: 100, //意外每日住院津贴
            CS: 50000,//猝死
            RBF: 3,// 日保费
        }
    },
    {
        name: '计划二',
        value: 'ZYBDTTYWXB',
        optionSelect: {
            YWSGSC: 300000, //意外身故及伤残保障
            YWYYBT: 30000, //意外医药补贴
            YWMRJT: 100, //意外每日住院津贴
            CS: 150000,//猝死
            RBF: 6,// 日保费
        }
    }
]
export default { ...obj }